import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react'

export default function FeatureCard({ 
  icon: Icon, 
  title, 
  description, 
  href, 
  index = 0,
  variant = 'default' 
}) {
  const variants = {
    default: 'bg-void-900/50 border-void-800/50 hover:border-synth-700/50',
    highlighted: 'bg-gradient-to-br from-synth-900/50 to-void-900/50 border-synth-700/30 hover:border-synth-600/50',
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link
        to={href}
        className={`group block p-6 rounded-2xl border backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-synth-900/20 ${variants[variant]}`}
      >
        <div className="flex items-start justify-between mb-4">
          <div className={`p-3 rounded-xl ${
            variant === 'highlighted' 
              ? 'bg-synth-600/20 text-synth-400' 
              : 'bg-void-800/50 text-void-400 group-hover:text-synth-400 group-hover:bg-synth-900/30'
          } transition-colors`}>
            <Icon className="w-6 h-6" />
          </div>
          <ArrowUpRight className="w-5 h-5 text-void-600 group-hover:text-synth-400 transition-colors transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
        
        <h3 className="text-lg font-display font-semibold text-void-100 mb-2 group-hover:text-synth-300 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-void-400 leading-relaxed">
          {description}
        </p>
      </Link>
    </motion.div>
  )
}
